import httpService from '../../../core/services/HttpService';
import { EventsResponse, CustomEvent, CustomEventCreateData } from '../types';

export default class EventService {
  static async getEvents(locationId: number, start?: string, days?: number): Promise<EventsResponse> {
    const params: Record<string, string> = { location_id: String(locationId) };
    if (start) params.start = start;
    if (days) params.days = String(days);
    const query = new URLSearchParams(params).toString();
    const response = await httpService.get<EventsResponse>(`/api/admin/events/?${query}`);
    return response.data;
  }

  static async createCustomEvent(data: Partial<CustomEventCreateData>): Promise<CustomEvent> {
    const response = await httpService.post<CustomEvent>('/api/admin/events/custom/', data);
    return response.data;
  }

  static async updateCustomEvent(id: number, data: Partial<CustomEvent>): Promise<CustomEvent> {
    const response = await httpService.put<CustomEvent>(`/api/admin/events/custom/${id}/`, data);
    return response.data;
  }

  static async deleteCustomEvent(id: number): Promise<void> {
    await httpService.delete(`/api/admin/events/custom/${id}/`);
  }
}
